export default __webpack_public_path__ + "static/media/on_2.c5cff966.mp3";